var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import SavedTranscriptTypes from '../action-types/saved-transcript';
import { selectLastReadTimestamp, selectLoading, selectTranscripts } from '../selectors/saved-transcript';
import { selectUser } from '../selectors/user';
import firebase, { authInstance, restName } from '../firebase';
import { deleteManyTranscriptsFromUser, deleteTranscriptFromUser, updateTranscriptTitleForUser, } from '../firebase/saved-transcript';
import { cloudTranscriptsEndpoint } from '../utils/http';
export const fetchTranscriptsRequest = () => ({
    type: SavedTranscriptTypes.FETCH_TRANSCRIPTS_REQUEST,
});
export const fetchTranscriptsSuccess = (transcripts) => ({
    type: SavedTranscriptTypes.FETCH_TRANSCRIPTS_SUCCESS,
    payload: transcripts,
});
export const fetchTranscriptsFailure = (errorMessage) => ({
    type: SavedTranscriptTypes.FETCH_TRANSCRIPTS_FAILURE,
    payload: errorMessage,
});
export const setHasMoreTranscripts = (hasMore) => ({
    type: SavedTranscriptTypes.SET_HAS_MORE_TRANSCRIPTS,
    payload: hasMore,
});
export const fetchTranscriptsRequestAsync = () => {
    return (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            const state = getState();
            //  Don't dispatch another action if already fetching transcripts
            const loading = selectLoading(state);
            if (loading)
                return;
            dispatch(fetchTranscriptsRequest());
            const firebaseUser = firebase.auth().currentUser;
            if (!firebaseUser)
                return;
            const user = selectUser(state);
            let endpoint = `${cloudTranscriptsEndpoint}?avaId=${user.avaId}&firebaseAuthID=${firebaseUser.uid}&limit=10`;
            const transcripts = selectTranscripts(state);
            if (transcripts.length > 0) {
                const lastReadTimestamp = selectLastReadTimestamp(state);
                endpoint += `&before=${lastReadTimestamp}`;
            }
            const token = yield ((_a = authInstance.currentUser) === null || _a === void 0 ? void 0 : _a.getIdToken());
            const { data } = yield axios.get(endpoint, {}, {
                auth: { username: restName, password: token },
            });
            if (data.length) {
                dispatch(fetchTranscriptsSuccess(data));
            }
            else {
                dispatch(setHasMoreTranscripts(false));
            }
        }
        catch (error) {
            dispatch(fetchTranscriptsFailure(error.message));
        }
    });
};
export const deleteTranscriptRequest = () => ({
    type: SavedTranscriptTypes.DELETE_TRANSCRIPT_REQUEST,
});
export const deleteTranscriptSuccess = (deletedTranscript) => ({
    type: SavedTranscriptTypes.DELETE_TRANSCRIPT_SUCCESS,
    payload: deletedTranscript,
});
export const deleteManyTranscriptSuccess = (roomIds) => ({
    type: SavedTranscriptTypes.DELETE_MANY_TRANSCRIPTS_SUCCESS,
    payload: roomIds,
});
export const deleteTranscriptFailure = (errorMessage) => ({
    type: SavedTranscriptTypes.DELETE_TRANSCRIPT_FAILURE,
    payload: errorMessage,
});
export const deleteTranscriptRequestAsync = ({ avaId, transcript }) => {
    return (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            dispatch(deleteTranscriptRequest());
            yield deleteTranscriptFromUser({
                userId: avaId,
                roomId: transcript.roomId,
            });
            dispatch(deleteTranscriptSuccess(transcript));
        }
        catch (err) {
            dispatch(deleteTranscriptFailure(err.message));
        }
    });
};
export const deleteManyTranscriptsRequestAsync = ({ avaId, transcripts, }) => {
    return (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            dispatch(deleteTranscriptRequest());
            const roomIds = transcripts.map((t) => t.roomId);
            const deletedTranscriptRoomIds = yield deleteManyTranscriptsFromUser({
                userId: avaId,
                roomIds,
            });
            dispatch(deleteManyTranscriptSuccess(deletedTranscriptRoomIds));
        }
        catch (err) {
            dispatch(deleteTranscriptFailure(err.message));
        }
    });
};
export const setSelectedTranscriptId = (id) => ({
    type: SavedTranscriptTypes.SET_SELECTED_TRANSCRIPT_ID,
    payload: id,
});
export const resetTranscripts = () => ({
    type: SavedTranscriptTypes.RESET_TRANSCRIPTS,
});
export const updateTranscriptTitleRequest = () => ({
    type: SavedTranscriptTypes.UPDATE_TRANSCRIPT_TITLE_REQUEST,
});
export const updateTranscriptTitleSuccess = (updatedTranscript) => ({
    type: SavedTranscriptTypes.UPDATE_TRANSCRIPT_TITLE_SUCCESS,
    payload: updatedTranscript,
});
export const updateTranscriptTitleFailure = (errorMessage) => ({
    type: SavedTranscriptTypes.UPDATE_TRANSCRIPT_TITLE_FAILURE,
    payload: errorMessage,
});
export const updateTranscriptTitleRequestAsync = ({ avaId, transcript, title, }) => {
    return (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            dispatch(updateTranscriptTitleRequest());
            yield updateTranscriptTitleForUser({
                userId: avaId,
                roomId: transcript.roomId,
                title,
            });
            const updatedTranscript = Object.assign(Object.assign({}, transcript), { title });
            dispatch(updateTranscriptTitleSuccess(updatedTranscript));
        }
        catch (err) {
            dispatch(updateTranscriptTitleFailure(err.message));
        }
    });
};
export const addNewTranscript = (newTranscript) => ({
    type: SavedTranscriptTypes.ADD_NEW_TRANSCRIPT,
    payload: newTranscript,
});
